import { bnrFixClose } from './tlm_modules/bnrFixClose';
import { hamburgerToggle, headerConfig, megaMenuToggle } from './tlm_modules/headerUiAction';
import { moviePlay } from './tlm_modules/moviePlay';
import { popupView } from './tlm_modules/popUpView';
import { scrollMagic } from './tlm_modules/scrollMagic';
import { smooth } from './tlm_modules/smoothAnchor';
import { indexSwiper, sliderControlBtn } from './tlm_modules/swiperConfig';
import { windowAction } from './tlm_modules/windowAction';
import { langUrlChange } from './modules/langUrlChange';
hamburgerToggle();
headerConfig();
megaMenuToggle();
smooth();
popupView();
sliderControlBtn();
indexSwiper();
scrollMagic();
windowAction();
moviePlay();
bnrFixClose();

langUrlChange();
